import {
  ADDITIONALS_ROUTES,
  HOME_PAGES_ROUTES,
  SIGNIN_PAGES_ROUTES,
  TESTS_ROUTES,
} from "constants/routes";
import { AuthRoute } from "layout/AuthRoute";
import { Additionals, Home, NotFound, Preview, SignIn, Test } from "pages";
import type React from "react";
import { Route, Switch } from "react-router-dom";

const AppRouter = (): React.ReactElement => (
  <Switch>
    <AuthRoute
      exact
      component={Home}
      path={HOME_PAGES_ROUTES.HOME_PAGE}
      redirectPath={SIGNIN_PAGES_ROUTES.SIGNIN_PAGE}
    />
    <AuthRoute exact publicRoute component={SignIn} path={SIGNIN_PAGES_ROUTES.SIGNIN_PAGE} />
    <AuthRoute
      exact
      component={Test}
      path={TESTS_ROUTES.TEST_PAGE}
      redirectPath={SIGNIN_PAGES_ROUTES.SIGNIN_PAGE}
    />
    <AuthRoute
      exact
      component={Additionals}
      path={ADDITIONALS_ROUTES.ADDITIONALS_DETAIL}
      redirectPath={SIGNIN_PAGES_ROUTES.SIGNIN_PAGE}
    />
    <AuthRoute
      exact
      component={Preview}
      path={ADDITIONALS_ROUTES.ADDITIONALS_PREVIEW}
      redirectPath={SIGNIN_PAGES_ROUTES.SIGNIN_PAGE}
    />
    <Route component={NotFound} />
  </Switch>
);

export default AppRouter;
